import React from "react";
import secureImage from "../assets/figma/Secure.png";
import playStore from "../assets/logo/Play store.png";
import appStore from "../assets/logo/App store.png";
import "./SecureConnected.css";

export default function SecureConnected({ id }) {
  return (
    <section className="secure-connected-section tl-reveal" id={id}>
      <div className="secure-connected-copy">
        <h2>
          Simple
          <br />
          Fast
          <br />
          Reliable
        </h2>
        <div className="secure-store-badges">
          <img src={playStore} alt="Download on Google Play" />
          <img src={appStore} alt="Download on the App Store" />
        </div>
      </div>
      <div className="secure-connected-visual">
        <img src={secureImage} alt="trilLOAN app screens" />
      </div>
    </section>
  );
}
